import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { metersQueryKey } from '../queries/useMeters'

export function useDeleteMeter() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError()

  async function deleteMeter(id: string) {
    await apiClient.delete(SNA_PREFIX + `meters/${id}`)
  }

  return useMutation({
    mutationFn: deleteMeter,
    onSuccess: () => {
      toast.success({ message: t('meterDeleted') })
      queryClient.invalidateQueries({ queryKey: metersQueryKey })
    },
    onError
  })
}
